import React from "react";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Typography } from "@mui/material";
import { boxStyle } from "./style/BoxStyle";

const AccessForbidden = () => {
    return (
        <Box sx={boxStyle}>
            <FontAwesomeIcon icon={faLock} size="4x" style={{ color: '#333' }} />
            <Typography variant="h3" mt={2} fontWeight="bold">
                403 Forbidden
            </Typography>
            <Typography variant="body1" mt={1} mb={3}>
                You don’t have permission to access this page.
            </Typography>
        </Box>
    )
};

export default AccessForbidden;
